<template>
<div class="login-tag">
  <div class="is-flex is-justify-content-center is-align-items-center login-main">
    <div class="card">
        <header class="">
          <div v-if='!showForgot'
            class="card-header-title  mb-5 has-text-dark is-justify-content-center is-size-5"
          >
          Welcome, Please  Log In
        </div>
          <div v-else
            class="card-header-title is-uppercase has-text-dark is-justify-content-center is-size-5"
          >
            {{ $t('reset Password') }}
          </div>
          <div class="is-flex is-justify-content-center mb-2">
            <img src="../assets/logo-login.svg" width="250" height="100%">
          </div>
        </header>
        <div class="card-content">
          <div class="field">
            <div class="field-label">
              <label class="label is-italic has-text-dark">User Name:</label>
            </div>
            <p class="control has-icons-left has-icons-right">
              <input
                class="input has-text-dark"
                v-model.trim="user.email"
                type="email"
                :placeholder="$t('Email Address')"
                @keyup.enter="login()"
              />
              <span class="icon is-small is-left">
                <i class="icon-email"></i>
              </span>
            </p>
          </div>
          <div class="field" v-if='!showForgot'>
            <div class="field-label">
              <label class="label is-italic has-text-dark">Password:</label>
            </div>
            <p class="control has-icons-left has-icons-right">
              <input
                class="input has-text-dark"
                :type="showPassword ? 'text' : 'password'"
                v-model="user.password"
                :placeholder="$t('Password')"
                @keyup.enter="login()"
              />
              <span class="icon is-small is-left">
                <i class="icon-lock"></i>
              </span>
              <span
                class="icon is-small is-right is-clickable"
                @click="showPassword = !showPassword"
                @mouseover="
                  showPassword
                    ? (eyeIcon = 'icon-hide')
                    : (eyeIcon = 'icon-show')
                "
                @mouseleave="
                  showPassword
                    ? (eyeIcon = 'icon-show')
                    : (eyeIcon = 'icon-hide')
                "
              >
                <i :class="eyeIcon"></i>
              </span>
            </p>
          </div>
          <p class="line-height mb-10" v-if='!showForgot'><a @click="showForgot=!showForgot">
            {{ $t('Forgot password?') }}</a>
          </p>
          <p v-else class="is-size-3 line-height">
            {{ $t('Enter your registered email address and we will email a link to reset your password.') }}</p>
           <p class="has-text-left has-text-dark">
          {{ $t('By logging in, you accept the Manufacton') }}
          <a
          href="https://www.allplan.com/fileadmin/user_upload/countries/united-states/PDFs/MANUFACTON_Terms-and-Conditions.pdf"
            target="_blank"
          >{{ $t('Terms & Conditions') }}</a> {{ $t('and') }}
          <a
            href="#/manufacton-privacy-policy"
            target="_blank"
          >{{ $t('Privacy Policy') }}</a>.
        </p>
        </div>
        <footer
          class="card-footer is-justify-content-flex-end -small"
        >
          <button v-if='!showForgot'
            class="button is-dark is-capitalized has-text-weight-bold"
            @click="login()"
          >
            {{ $t('log in') }}
          </button>
          <div v-else class="buttons">
            <button class="button is-outlined has-text-weight-bold"
              @click="showForgot=!showForgot">{{ $t('Cancel') }}</button>
            <button class="button is-dark is-capitalized has-text-weight-bold"
              @click="sendMail()">{{ $t('Email Reset Password Link') }}</button>
          </div>
        </footer>
      </div>
  </div>
</div>
  <o-loading
    :full-page="true"
    :active="isLoading"
    :can-cancel="true"
  ></o-loading>
</template>

<script>
import {
  computed,
  reactive, toRefs,
} from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import _ from 'lodash';
import Validation from '@/utils/Validations';
import User from '@/models/Users';
import { useToast } from 'vue-toastification';
import Version from '@/appVersion.json';
import { getBrowserType } from '../utils/Browser';

export default {
  name: 'login',
  setup() {
    const store = useStore();
    const router = useRouter();
    const toast = useToast();
    const state = reactive({
      showPassword: false,
      user: {
        email: '',
        password: '',
        device: {
          platform: getBrowserType(),
          appVersion: Version.appVersion
        }
      },
      landingPage: {
        home: '/home',
        mm: '/materials/preparation',
        prefabs: '/prefabs-list',
        pm: '/manager/detailing',
        scm: '/scm/production-status/order-view',
        schedules: 'schedule-list',
      },
      showForgot: false,
      icons: ['times-circle', 'exclamation-circle'],
      currentInstance: '',
      isLoading: false,
      eyeIcon: 'icon-hide',
    });

    const login = async () => {
      if (Validation.validateEmail(state.user.email)) {
        state.isLoading = true;
        try {
          const result = await User.login(state.user);
          localStorage.setItem('auth-token', result.token);
          localStorage.setItem('licenseExpiresIn', result.user.licenseExpiresIn);
          localStorage.setItem('refreshableUntil', result.user.refreshableUntil);
          await store.dispatch('getUserData');
          store.commit('setLoggedIn', true);
          await store.getters.userPromise;
          const user = store.state.userData;
          await store.dispatch('updateProjects');
          ['projects', 'projectsAndGI'].forEach((key) => {
            if (user.rememberLastUsedProjects) {
              if (store.state.queryParams.isActiveSelected[key]) { store.commit('setIsActiveSelectedVal', key, false); }
              if (_.get(store.state.queryParams, 'projects.length', 0) === 0) store.commit('setQueryParams', { [key]: store.state.queryParams._projects });
            } else {
              store.dispatch('selectActiveProjects', key);
            }
          });
          store.commit('setQueryParams', {
            searchBy: { label: 'Order Name', value: 'name' }
          });
          // oruga.notification.open({
          //   message: 'You are now logged in',
          //   variant: 'success',
          // });
          // initialize pendo once login is success
          if (process.env.NODE_ENV === 'production') {
            const userData = await store.getters.userPromise;
            // eslint-disable-next-line
            pendo.initialize({
              visitor: {
                id: userData._id,
                email: userData.email,
                userName: userData.firstName,
                role: userData.role,
              },
              account: {
                id: userData.company,
                name: userData.companyName,
              },
            });
          }
          // navigating based on user settings default landing
          router.push({ path: state.landingPage[store.state.userData.defaultLanding] });
        } catch (e) {
          // alertMessage(e);
            const status = e?.response?.status;
            if (status === 303) {
              window.location.reload();
              return;
            }
            if (status !== 303) toast.error('Cannot log in with this user name and password');
          }
        state.isLoading = false;
      } else {
        toast.error('Email Address is Not Valid');
      }
    };
    const alertMessage = (err) => {
      if (err.status === 404) {
        return toast.error('Looks like server is down !!!');
      }
      return toast.error(
        _.get(err, 'data.message', false)
          ? err.data.message
          : 'Something went wrong!',
      );
    };
    const callToast = (msg) => {
      // oruga.notification.open({
      //   message: `${msg}`,
      //   variant: 'danger',
      // });
    };
    const sendMail = async () => {
      if (Validation.validateEmail(state.user.email)) {
        try {
          await User.forgotPassword(state.user);
          return toast.success('We have sent you an email with instruction on how to reset your password!', 'success');
        } catch (e) {
          return alertMessage(e);
        }
      } else {
        return toast.error('Email Address is Not Valid');
      }
    };

    return {
      ...toRefs(state),
      login,
      alertMessage,
      callToast,
      sendMail,
    };
  },
};
</script>

<style scoped>
.card {
  width: 432px;
  border-radius: 8px;
}
::v-deep(.eye-button) {
  position: absolute;
  right: 7px;
  top: 7px;
}
.control.has-icons-left .icon.is-left,
.control.has-icons-right .icon.is-right {
  height: 100%;
}

</style>
